export default "9e55a13d57ab69e5.svg"